import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
export const smallCardGrid = css`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: repeat(4, auto);
  padding: 16px;
  row-gap: 8px;

  .header {
    grid-area: 1 / 2 / 2 / 3;
    padding: 0;
    position: relative;

    .pictogram {
      display: grid;
      grid-area: 2 / 1 / 3 / 2;
      height: 2rem;
      margin-inline-end: 8px;
      margin-top: 2px;
      position: absolute;
      width: 2rem;
    }

    .title {
      align-items: flex-start;
      grid-area: 2 / 2 / 3 / 3;
      margin-inline-start: 40px;
    }
  }

  .body {
    grid-area: 2 / 2 / 3 / 3;
    margin-inline-start: 40px;
    margin-top: -4px;
    padding: 0;

    .description {
      line-height: 1.4;
      margin-bottom: 0;

      .link {
        display: inline;
      }
    }
  }

  .readMore {
    grid-area: 3 / 2 / 4 / 3;
    margin-inline-start: 0;
    padding: 0;

    @media (min-width: ${breakpoints._768}) {
      margin-inline-start: 40px;
    }
  }

  .cta {
    column-gap: 0;
    grid-area: 4 / 2 / 5 / 3;
    grid-template-columns: 0 1fr;
    padding: 0;

    @media (min-width: ${breakpoints._768}) {
      column-gap: 8px;
      grid-template-columns: repeat(2, auto);
    }

    .selection {
      grid-area: 1 / 2 / 2 / 3;
      margin-bottom: 4px;

      @media (min-width: ${breakpoints._768}) {
        margin-bottom: 2px;
      }
    }

    &:not(:has(legend)) {
      .buttonWrapper {
        margin-top: 22px;

        @media (min-width: ${breakpoints._768}) {
          margin-top: 0;
        }
      }

      .priceLabel {
        margin-top: 8px;
      }
    }

    .children {
      display: contents;
    }
  }
`;
//# sourceMappingURL=styles.js.map